/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PracticeUserDto } from './PracticeUserDto';
import {
    PracticeUserDtoFromJSON,
    PracticeUserDtoFromJSONTyped,
    PracticeUserDtoToJSON,
    PracticeUserDtoToJSONTyped,
} from './PracticeUserDto';
import type { PracticeUsersPaginationDto } from './PracticeUsersPaginationDto';
import {
    PracticeUsersPaginationDtoFromJSON,
    PracticeUsersPaginationDtoFromJSONTyped,
    PracticeUsersPaginationDtoToJSON,
    PracticeUsersPaginationDtoToJSONTyped,
} from './PracticeUsersPaginationDto';

/**
 * 
 * @export
 * @interface PracticeUsersResponseDto
 */
export interface PracticeUsersResponseDto {
    /**
     * List of practice users
     * @type {Array<PracticeUserDto>}
     * @memberof PracticeUsersResponseDto
     */
    practiceUsers: Array<PracticeUserDto>;
    /**
     * Pagination information
     * @type {PracticeUsersPaginationDto}
     * @memberof PracticeUsersResponseDto
     */
    pagination: PracticeUsersPaginationDto;
}

/**
 * Check if a given object implements the PracticeUsersResponseDto interface.
 */
export function instanceOfPracticeUsersResponseDto(value: object): value is PracticeUsersResponseDto {
    if (!('practiceUsers' in value) || value['practiceUsers'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function PracticeUsersResponseDtoFromJSON(json: any): PracticeUsersResponseDto {
    return PracticeUsersResponseDtoFromJSONTyped(json, false);
}

export function PracticeUsersResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PracticeUsersResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'practiceUsers': ((json['practiceUsers'] as Array<any>).map(PracticeUserDtoFromJSON)),
        'pagination': PracticeUsersPaginationDtoFromJSON(json['pagination']),
    };
}

export function PracticeUsersResponseDtoToJSON(json: any): PracticeUsersResponseDto {
    return PracticeUsersResponseDtoToJSONTyped(json, false);
}

export function PracticeUsersResponseDtoToJSONTyped(value?: PracticeUsersResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'practiceUsers': ((value['practiceUsers'] as Array<any>).map(PracticeUserDtoToJSON)),
        'pagination': PracticeUsersPaginationDtoToJSON(value['pagination']),
    };
}

